<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        small
        class="ml-2"
        v-on="on"
      >
        <v-icon
          v-if="socsoDetail.socso_number"
          color="primary"
        >
          mdi-pencil
        </v-icon>

        <v-icon
          v-else
          color="hrissecondary"
        >
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Employee SOCSO Detail"
      :text="socsoDetail.socso_number ? 'Update employee SOCSO detail':'Create employee SOCSO detail'"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="socsoNumber"
                v-validate="socsoDetail.is_malaysian ? 'required|numeric|length:12' : 'required|alpha_num|length:12'"
                counter="12"
                maxlength="12"
                :error-messages="errors.collect('socsoNumber')"
                data-vv-name="socsoNumber"
                data-vv-as="SOCSO number"
                label="SOCSO Number"
                :hint="socsoDetail.is_malaysian ? '12 digits only. Defaults to IC number for Malaysian employees' : ''"
                :persistent-hint="!!socsoDetail.is_malaysian"
                @input="socsoNumber = (socsoNumber || '').toUpperCase()"
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>  
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      socsoDetail: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        socsoNumber: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.socsoNumber = this.socsoDetail.socso_number

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.employeePayrollSocso().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          socso_number: this.socsoNumber,
        }
      },
    },
  }
</script>
